<template lang="pug">
.account-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    // セル：権限変更ボタン
    template(#cell(operation)="row")
      .d-flex.flex-row.justify-content-center.align-items-center
        button.btn.edit-btn.mr-2(@click="onEdit(row.item)") 権限変更
        button.btn.delete-btn(@click="onDelete(row.item)") 削除
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import HelpIcon from "@/pc/basics/HelpIcon.vue";

/**
 * 利用者テーブルコンポーネント
 */
@Component({
  components: {
    HelpIcon
  }
})
export default class AccountTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<AccountTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<AccountTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  get _value(): Array<AccountTableItem> {
    return this.value;
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: AccountTableItem, filter: FilterSetting): boolean {
    return this.filterSearchWords(row, filter);
  }

  public filterSearchWords(row: AccountTableItem, filter: FilterSetting): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundUserId: boolean = true;
    let foundName: boolean = true;

    for (const word of words) {
      if (row.userId.indexOf(word) == -1) {
        foundUserId = false;
      }
      if (row.name.indexOf(word) == -1) {
        foundName = false;
      }
    }

    return foundUserId || foundName;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(account: AccountTableItem): void {
    this.$emit("onEdit", account);
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   */
  public onDelete(account: AccountTableItem): void {
    this.$emit("onDelete", account);
    return;
  }
}

/** テーブルの列名の情報 */
export interface AccountTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface AccountTableItem {
  userId: string;
  name: string;
  kana: string;
}

export interface FilterSetting {
  searchWord: string;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.used {
  color: $font-key-color;
  font-weight: bold;
}
.unused {
  color: $font-disable-font-color;
}

.account-table-component {
  .used {
    color: $font-key-color;
    font-weight: bold;
  }
  .unused {
    color: $font-disable-font-color;
  }

  .delete-btn,
  .edit-btn {
    width: 104px;
  }
}
</style>
